export class FreeReducedMealAppChildProgram {
    ID: number;
    AppID: number;
    ProgramID: number;
    Selected: boolean;
   }